import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@services/login.service';
import { MessagesService } from '@services/messages.service';

@Component({
  selector: 'app-nueva-password',
  templateUrl: './nueva-password.component.html',
  styleUrls: ['./nueva-password.component.css'],
  imports: [CommonModule, ReactiveFormsModule],
})

export class NuevaPasswordComponent {
  form: FormGroup;
  submitted = false;
  public paraemail: string = '';

  constructor(private fb: FormBuilder,public router: Router, private msg:MessagesService,
       protected rt: ActivatedRoute,private loginService: LoginService) {
    this.form = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
    
    this.paraemail = this.rt.snapshot.paramMap.get('crytemail') || '';

  }

  passwordMatchValidator(form: FormGroup) {
    return form.get('password')!.value === form.get('confirmPassword')!.value
      ? null : { mismatch: true };
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      // Llamada al backend para actualizar la contraseña
      this.loginService.ActualizaPassword({ email: this.paraemail, password: this.form.value.password }).then(response => {
        this.msg.mensajeRapido('La contraseña se ha actualizado correctamente. Por favor, inicia sesión con tu nueva contraseña.','Contraseña Actualizada','success');
        this.router.navigate(['/']);
      }).catch(error => {
        console.error('Error al actualizar la contraseña:', error);
        this.msg.mensajeRapido('Hubo un error al actualizar la contraseña. Inténtalo de nuevo.','Error','error');
      }); 
      
    }
  }


  public passwordFieldType: string = 'password';
  public confirmPasswordFieldType: string = 'password';

  togglePassword(field: 'password' | 'confirm') {
    if (field === 'password') {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    } else {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
    }
  }
}
